import React from 'react';
import { TextField, Box, InputLabel, IconButton, Tooltip } from '@mui/material';
import { AutoAwesome } from '@mui/icons-material';
import { useFormContext, Controller } from 'react-hook-form';

import type { FieldError } from 'react-hook-form';
import type { CampaignQuestion } from '../../types';

interface QuestionTextFieldProps {
    question: CampaignQuestion;
    error?: FieldError;
    fieldIndex?: number;
}

/**
 * Expandable textarea input field for a question.
 */
const QuestionTextField: React.FC<QuestionTextFieldProps> = ({ question, error, fieldIndex }) => {
    const inputId = `question-text-${question.id}`;
    const formContext = useFormContext();

    return (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <InputLabel htmlFor={inputId} error={!!error}>
                    Question
                </InputLabel>
                <Tooltip title="Test and refine your question with LeadGPT (coming soon)" placement="top" arrow>
                    <Box component="span">
                        <IconButton color="primary" disabled={true} size="small" sx={{ padding: 0.5, marginTop: -0.75 }}>
                            <AutoAwesome sx={{ fontSize: '1rem' }} />
                        </IconButton>
                    </Box>
                </Tooltip>
            </Box>
            <Controller
                name={`questions.${fieldIndex}.text` as const}
                control={formContext.control}
                render={({ field }) => (
                    <TextField
                        {...field}
                        id={inputId}
                        size="small"
                        variant="outlined"
                        fullWidth
                        multiline={true}
                        minRows={3}
                        maxRows={10}
                        error={!!error}
                        helperText={error?.message}
                    />
                )}
            />
        </Box>
    );
};

export default React.memo(QuestionTextField);
